import { Builder_, Dropdown_, Input_, Section_Title, Upload_Logo } from 'monica-alexandria';
import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ReportStyleContext } from '../../../../context/ReportStyleContext';
import Style_Preset_Editor_Colors from './Style_Preset_Editor_Colors';
import axios from 'axios';
import { config } from '../../../../../../config';
import { FileContext } from '../../../../context/FileContext';

const StylePresetEditor = styled.div``;

export default function Style_Preset_Editor() {
    const { t } = useTranslation();
    const { reportStyle, setReportStyle } = useContext(ReportStyleContext);
    const doitformeLogo = "https://genius1071.friktoriaservers.net/doitforme/logo/logo_light.svg";

    const [img, setImg] = useState();
    const [imgStatus, setImageStatus] = useState();
    const { file, setFile } = useContext(FileContext);

    const change_radius = (event) => {
        const newRadius = event.target.value;
        setReportStyle((prev) => ({
            ...prev,
            radius: newRadius === 'none' ? false : newRadius,
        }));
    };

    const change_font_family = (event) => {
        const newFontFamily = event.target.value;
        setReportStyle((prev) => ({
            ...prev,
            font: {
                family: newFontFamily,
            },
        }));
    };

    const upload_pic = async (files) => {
        if (files?.length && files[0]?.preview) {
            console.log(files);
            setImg( files[0].preview);
            setImageStatus(true);
            setFile(files[0]);
            setReportStyle((prev) => ({
                ...prev,
                logo: files[0].preview
            }))
        }
    };


    const handleBoomRejected = (type) => {

        console.log('TYPe', type);
        let reason = '';
        switch (type) {

            case 'fileMimetype': {
                reason = (t('File must be png, jpeg, mp4, mpeg, webm'));
                break;
            }
            case 'fileSize': {
                reason = (t('Invalid image size. Image must be less than 6MB'));
                break;
            }
        }
        // alertMessage(alerts, setAlerts, t('Could not upload image. Reason')+": "+reason,'Error');
    };
    


    return (
        <StylePresetEditor>
            <Section_Title text={t('Live Editor')} />
            <Builder_ title={t("Enter your brand name")}>
                <Input_ placeholder={t("Brand name")} required value={reportStyle?.brand} onChange={(e) => setReportStyle((prev) => ({ ...prev, brand: e.target.value }))} />
            </Builder_>
            <Builder_ title={t("Upload your logo")}>
                <Upload_Logo 
                    upload={t('Upload')} 
                    img={img ? img : doitformeLogo} 
                    getFilesFromChild={(files) => upload_pic(files)} 
                    boomRejected={(type) => handleBoomRejected(type)}
                    uploaded={imgStatus}
                />
            </Builder_>
            <Builder_ title={t("Font family")}>
                <Dropdown_>
                    <select onChange={change_font_family}>
                        <option value="">Default</option>
                        <option value="Arial">Arial</option>
                        <option value="Verdana">Verdana</option>
                        <option value="Tahoma">Tahoma</option>
                        <option value="Trebuchet">Trebuchet</option>
                        <option value="Times New Roman">Times New Roman</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Garamond">Garamond</option>
                        <option value="Courier New">Courier New</option>
                    </select>
                </Dropdown_>
            </Builder_>
            <Builder_ title={t("Border radius")}>
                <Dropdown_>
                    <select onChange={change_radius}>
                        <option value="none">None</option>
                        <option value="3rem" selected>
                            Large
                        </option>
                        <option value="1rem">Small</option>
                    </select>
                </Dropdown_>
            </Builder_>
            <Builder_ title={t("Colors")}>
                <Style_Preset_Editor_Colors />
            </Builder_>
        </StylePresetEditor>
    );
}
